<template>
  <div class="help-center-component-title__component">
    <div
      v-if="component.title_icon"
      class="help-center-component-title__user-background"
      :style="boxStyles"
    >
      <i
        class="help-center-component-title__user-icon"
        :class="component.title_icon"
      />
    </div>
    <a
      :id="component.fragment"
      :href="titleHref"
      class="help-center-component-title__link"
    >
      <component
        :is="titleTag"
        :class="titleClass"
        class="help-center-component-title__title"
      >
        {{ component.title }}
      </component>
    </a>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  component: {
    type: Object,
    required: true
  }
})

const boxStyles = computed(() => {
  return {
    'background-color': props.component.title_icon_color
  }
})

const titleTag = computed(() => {
  // ensuring there's only one H1 on a page
  return `h${props.component.title_level + 1}`
})

const titleHref = computed(() => {
  return '#' + props.component.fragment
})

const titleClass = computed(() => {
  switch (props.component.title_level) {
  case 1:
    return 'help-center-component-title__title--24'
  case 2:
    return 'help-center-component-title__title--20'
  case 3:
    return 'help-center-component-title__title--18'
  case 4:
  case 5:
  case 6:
  default:
    return 'help-center-component-title__title--16'
  }
})
</script>

<style lang="scss">
@import 'help-center/mixins';

.help-center-component-title {
  &__component {
    gap: 8px;
    display: flex;
    align-items: center;
  }

  &__user-background {
    flex: none;
    display: flex;
    align-items: center;
    justify-content: center;

    width: 32px;
    height: 32px;
    border-radius: 6px;
  }

  &__user-icon {
    @include help-center-icon(20);
    color: white;
  }

  &__link {
    @include help-center-accent-link($userSelect: true);
    gap: 8px;
    display: flex;
    align-items: center;
  }

  &__title {
    text-wrap: balance;
    font-weight: var(--help-center-bold);

    &--24 {
      @include help-center-font(24, title);
    }

    &--20 {
      @include help-center-font(20, title);
    }

    &--18 {
      @include help-center-font(18, title);
    }

    &--16 {
      @include help-center-font(16, title);
    }
  }
}
</style>
